import type { PropsWithChildren } from "react";
import { useIsPaywallsModalsV3 } from "@/react/hooks/useIsPaywallsModalsV3";
import { Typography } from "@circle-react-uikit/Typography";

export const TabTitle = ({ children }: PropsWithChildren<unknown>) => {
  const isPaywallsModalsV3 = useIsPaywallsModalsV3();

  if (isPaywallsModalsV3) {
    return (
      <Typography.TitleXl truncate weight="font-bold">
        {children}
      </Typography.TitleXl>
    );
  }

  return (
    <div className="pt-7">
      <Typography.TitleSm weight="semibold">{children}</Typography.TitleSm>
    </div>
  );
};
